import { createContext, useContext } from "react";

import { AiInterviewerFragment } from "../../graphql";

export type AiInterviewerContextType = AiInterviewerFragment | null;

export const AiInterviewerContext =
  createContext<AiInterviewerContextType>(null);

export const useAiInterviewerContext = (): AiInterviewerFragment => {
  const context = useContext(AiInterviewerContext);
  if (!context) {
    throw new Error(
      "useAiInterviewerContext must be used within an AiInterviewerProvider"
    );
  }
  return context;
};
